"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var SwitchLanguage = function (_a) {
    var onLanguageSwitch = _a.onLanguageSwitch;
    var i18n = (0, react_i18next_1.useTranslation)().i18n;
    var lng = i18n.language;
    return react_1["default"].createElement("div", { className: "SwitchLanguage" },
        lng.startsWith("en") ? react_1["default"].createElement(react_1["default"].Fragment, null, "En|") : react_1["default"].createElement(react_1["default"].Fragment, null,
            react_1["default"].createElement("a", { onClick: function (e) { e.preventDefault(); onLanguageSwitch('en'); }, href: "#" }, "En"),
            "|"),
        lng.startsWith("fr") ? react_1["default"].createElement(react_1["default"].Fragment, null, "Fr") : react_1["default"].createElement(react_1["default"].Fragment, null,
            react_1["default"].createElement("a", { onClick: function (e) { e.preventDefault(); onLanguageSwitch('fr'); }, href: "#" }, "Fr")));
};
exports["default"] = SwitchLanguage;
